import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import { features } from '../config/features';

const About = () => {
  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="container">
          <h1>About Us</h1>
          <p>US. Society of Software Engineers stands for the profession which fuels the American software innovation.</p>
        </div>
      </div>

      <div className="container">
        <section className="about-mission">
          <div className="mission-content">
            <div className="mission-text">
              <h2>Mission</h2>
              <p>US. Society of Software Engineers stands at the forefront of creating, innovating, and maintaining the digital infrastructure that powers society’s economic, social, and technological advancements while ensuring security, accessibility, and sustainability.
Through the expertise of its vibrant community, the profession drives innovation through collaborative open-source projects, cutting-edge research, and continuous learning opportunities, serving as a leading source of technical knowledge, best practices, and industry standards that empower developers and protect users.
The community advances software engineering disciplines through specialized domains such as artificial intelligence, cybersecurity, and cloud computing, and leads with impactful programs that foster diversity and ethical development.</p>
              <p>Founded in 2021, our organization brings together software engineers, developers, architects, and other IT professionals from across the United States to share knowledge, best practices, and drive innovation in our industry.</p>
            </div>
            <div className="mission-image">
              <div className="image-placeholder">
                <i className="fas fa-bullseye"></i>
              </div>
            </div>
          </div>
        </section>
        <section className="about-values">
          <h2 className="section-title">Our Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-lightbulb"></i>
              </div>
              <h3>Put Americans and America First</h3>
              <p>We are Americans striving to do better for the country and next generation of engineering talent.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-hands-helping"></i>
              </div>
              <h3>Collaboration</h3>
              <p>We believe in the power of teamwork and knowledge sharing to solve complex problems and drive industry progress.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-graduation-cap"></i>
              </div>
              <h3>Continuing Education</h3>
              <p>We are committed to continuous learning and providing opportunities for professional development and skill enhancement.</p>
            </div>
          </div>
        </section>

        <section className="about-leadership">
          <h2 className="section-title">Leadership Team</h2>
          <div className="leadership-grid">
            <div className="leader-card">
              <div className="leader-avatar">
                <i className="fas fa-user"></i>
              </div>
              <h3>US Society of Software  Engineers</h3>
              <p className="leader-title">President & CEO</p>
              <p className="leader-bio">Software Engineer with 10+ years of experience in Google and Amazon.</p>
            </div>
          </div>
        </section>

        <section className="about-history">
          <div className="history-content">
            <div className="history-text">
              <h2>Our History</h2>
              <p>Founded in 2021, our organization was built on the belief that software engineering is not just a discipline, but a driving force for innovation and progress. Our mission is to advance the practice, principles, and impact of software engineering through excellence, education, and collaboration.
At the heart of our vision is the empowerment of the American engineer — enabling individuals to design, build, and lead with integrity, technical mastery, and creative freedom. We believe that by investing in the growth and strength of engineers, we strengthen the foundation of American innovation itself.</p>
            </div>
            <div className="history-timeline">
              <div className="timeline-item">
                <div className="timeline-date">March 2021</div>
                <div className="timeline-content">
                  <h4>Foundation</h4>
                  <p>Organization founded in 2021</p>
                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-date">Dec 2023</div>
                <div className="timeline-content">
                  <h4>First Conference</h4>
                  <p>Hosted inaugural software engineering conference in Las Vegas, NV.</p>
                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-date">May 2024</div>
                <div className="timeline-content">
                  <h4>Online website launched. </h4>
                  <p>Online website launced. To service </p>
                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-date">2025 and beyond</div>
                <div className="timeline-content">
                  <h4>We are excited for what is to come</h4>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="about-cta">
          <div className="cta-content">
            <h2>Join Our Community</h2>
            <p>Become part of the premier professional organization for software engineers in the United States</p>
            <div className="cta-buttons">
              {features.donate && <Link to="/donate" className="btn btn-primary">Donate</Link>}
              <Link to="/contact" className="btn btn-outline">Contact Us</Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About; 